.item {
    text-decoration: none;
    display: grid;
}

.font {
    font-family: var(--font-family);
    font-size: var(--font-size-body);
}

.item__color-border {
    background-color: var(--color-secondary);
    padding: var(--spacing-medium);
    border-radius: var(--border-small);
    gap: 0.5rem;
    box-shadow: var(--shadow-inline);
}

.item__shadow {
    border: 1px solid var(--color-border);
    border-radius: var(--border-small);
    margin: var(--spacing-small);
    box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
}

.item__content {
    background: white;
    padding: var(--spacing-medium);
    display: grid;
    align-items: center;
    gap: var(--spacing-small);
}

.item__logo {
    width: 35px;
    height: 35px;
    align-self: center;
}

.item__description {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1;
}

.item__book-name {
    color: var(--color-secondary);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-bold);
    line-height: 14px;
}

.item__cta {
    color: var(--color-primary);
    font-size: var(--font-size-title);
    font-weight: var(--font-weight-bold);
    line-height: 24px;
}

.item__terms {
    font-size: var(--font-size-tiny);
    line-height: 14px;
    color: var(--color-secondary);
    border-top: 1px solid var(--color-quaternary);
    padding-top: var(--spacing-tiny);
}

.item__date {
    display: flex;
    align-items: center;
    width: fit-content;
}

.item__date p {
    margin: 0px;
    font-size: var(--font-size-subcaption);
    line-height: 18px;
    color: var(--color-foreground);
}

.item__date svg {
    margin-left: 6px;
}

.item__promo-container {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-small);
}

.large__description {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
}

.large__terms {
    font-size: var(--font-size-tiny);
    line-height: 14px;
    color: var(--color-secondary);
    border-top: 1px solid var(--color-quaternary);
    padding-top: var(--spacing-tiny);
    text-align: center;
}

.large__date {
    width: 100%;
    text-align: center;
    padding-top: var(--spacing-smedium);
}

.large__date p {
    margin: 0px;
    font-size: var(--font-size-body);
    color: var(--color-foreground);
}

.large__date-bold {
    font-weight: var(--font-weight-bold);
}

.large__book-container {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-medium);
    align-items: center;
}

.large__content {
    background: white;
    padding: var(--spacing-medium);
    display: grid;
    align-items: center;
    gap: var(--spacing-small);
}

.large__cta {
    font-size: var(--font-size-hero);
    font-weight: 700;
    color: black;
    text-align: center;
}

.large__buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: var(--spacing-small);
}

.large__logo {
    width: 60px;
    height: 60px;
    align-self: center;
}

.large__title {
    color: var(--color-foreground);
    font-size: var(--font-size-hero);
    font-weight: var(--font-weight-bold);
    text-transform: uppercase;
}

.large__button {
    border: 1px solid var(--color-border);
    padding: var(--spacing-smedium) var(--spacing-medium);
    border-radius: var(--border-small);
    background: border-box var(--button-claim-color);
    cursor: pointer;
    flex: 1 1 10%;
    align-self: center;
    text-align: center;
}

.large__button-font {
    color: var(--button-claim-font-color);
    font-size: var(--font-size-title);
    font-weight: 800;
    line-height: 14px;
}

.buttons {
    width: 100%;
    display: flex;
    flex: 1 10%;
    justify-content: space-between;
    gap: var(--spacing-small);
}

.button {
    border: 1px solid var(--color-border);
    padding: var(--spacing-small) 0;
    border-radius: var(--border-small);
    background: border-box var(--button-claim-color);
    cursor: pointer;
    flex: 1 1 10%;
    align-self: center;
    text-align: center;
}

.button-font {
    color: var(--button-claim-font-color);
    font-size: var(--font-size-caption);
    font-weight: 800;
    line-height: 14px;
}

/* bonus code css */

.bonus-striped {
    background-image: repeating-linear-gradient(-45deg, #dbdbdb 0, #dbdbdb 0.5px, white 0, white 50%);
    background-size: 3px 3px;
    flex: 4;
    display: grid;
    grid-template-columns: 1fr 10fr;
    position: relative;
}

.bonus-striped-show {
    background-image: repeating-linear-gradient(-45deg, #dbdbdb 0, #dbdbdb 0.5px, white 0, white 50%);
    background-size: 3px 3px;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    align-self: center;
    min-height: 22px;
    padding: var(--spacing-tiny);
    color: var(--color-primary);
    font-size: var(--font-size-body);
    font-weight: 800;
    width: 100%;
    text-align: center;
}

.bonus-yellow {
    background: #fffdbf;
    background-size: 3px 3px;
    border-radius: 4px;
    border: 1px dashed #cecb7c;
    font-weight: 700;
    line-height: 54px;
    display: grid;
    grid-template-columns: 1fr;
    place-items: center;
    width: fit-content;
    padding: 0px var(--spacing-medium);
    align-self: center;
}

.bonus-yellow .bonus-code {
    font-size: var(--font-size-title);
}

.bonus-code-label {
    color: var(--color-secondary);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-tiny);
    white-space: nowrap;
    text-transform: uppercase;
    place-self: center;
    padding: var(--spacing-tiny);
}

.featured-bonus {
    background-color: var(--color-brand-tertiary);
}

.bonus,
.featured-bonus {
    place-self: center;
    flex: 1 1 50%;
    padding: var(--spacing-tiny);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 22px;
    line-height: var(--spacing-smedium);
}

.bonus:hover {
    background-color: var(--color-background);
    border: 1px dashed var(--color-secondary);
}

.featured-bonus:hover {
    border: 1px dashed var(--color-secondary);
}

.bonus-code {
    color: var(--color-primary);
    font-size: var(--font-size-body);
    font-weight: 800;
}

.bonus-text {
    color: var(--color-secondary);
    font-size: var(--font-size-caption);
    font-weight: 800;
    font-size: 9px;
}

.bonus-copy {
    color: var(--color-info);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
}

.no-code {
    color: var(--color-secondary);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
    line-height: var(--spacing-smedium);
}

.buttons {
    min-height: 40px;
}

.buttons-vert {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-small);
}

.buttons-vert .bonus {
    align-items: flex-end;
    place-self: flex-end normal;
}

.buttons-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-small) var(--spacing-small);
}

.bonus-fold {
    width: 0px;
    height: 0px;
    position: absolute;
    top: 0px;
    right: 0px;
    border-width: 0;
    border-style: solid;
    background: transparent;
    display: block;
    z-index: 10000;
    border-color: #f5deae transparent #f5deae transparent;

    -webkit-transition: border-width 0.2s ease-out;
    -moz-transition: border-width 0.2s ease-out;
    -ms-transition: border-width 0.2s ease-out;
    -o-transition: border-width 0.2s ease-out;
    transition: border-width 0.2s ease-out;
}

.bonus-striped:hover .bonus-fold {
    border-width: 0px 40px 40px 0px;
}

.bonus-lowerfold {
    width: 0px;
    height: 0px;
    position: absolute;
    top: 0px;
    right: 0px;
    border-width: 0;
    border-style: solid;
    display: block;
    width: 40px;
    height: 40px;
    z-index: 9999;

    background: #f4c256;
    background-position: -40px -40px;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);

    -webkit-transition: clip-path 0.2s ease-out;
    -moz-transition: clip-path 0.2s ease-out;
    -ms-transition: clip-path 0.2s ease-out;
    -o-transition: clip-path 0.2s ease-out;
    transition: clip-path 0.2s ease-out;
}

.bonus-striped:hover .bonus-lowerfold {
    clip-path: polygon(0 0, 50% 50%, 100% 100%, 0% 100%);
}

.bonus-cover {
    position: absolute;
    background-color: #f4c256;
    width: calc(100% - 40px);
    height: 40px;
    text-align: center;
    color: var(--color-primary);
    font-size: var(--font-size-body);
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bonus-arrow {
    color: var(--color-primary);
    display: flex;
    align-items: self-end;
    justify-content: center;
    font-style: italic;
}

.bonus-arrow__claim {
    margin-left: 0.5rem;
}

/* skeleton css */
.skeleton-item__logo {
    width: 35px;
    height: 35px;
    border-radius: var(--border-small);
    align-self: center;
    background-color: var(--color-background);
    animation: var(--loading);
}

.skeleton-item__description {
    flex-grow: 1;
    gap: 2px;
}
.skeleton-item__description > *:nth-of-type(odd) {
    height: var(--font-size-caption);
    width: 75px;
    background-color: var(--color-background);
    animation: var(--loading);
}
.skeleton-item__description > *:nth-of-type(even) {
    height: var(--font-size-subcaption);
    width: 100%;
    margin-top: 2px;
    margin-bottom: 2px;
    background-color: var(--color-background);
    animation: var(--loading);
}

.skeleton-button {
    background-color: var(--color-background);
    animation: var(--loading);
}

.button__corner {
    display: block;
    animation: peel-corner 3s ease 1s infinite;
    background: #ffcdac;
    border-bottom-left-radius: var(--border-small);
    border-top-left-radius: var(--border-small);
    box-sizing: border-box;
    content: '';
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    transform: rotate(-24.62deg) scale(1.1);
    transform-origin: right bottom;
    transition:
        right 0.25s linear,
        width 0.25s linear;
    width: 2.5%;
}

.bonus-input {
    width: calc(100% - 16px);
    border-style: dashed;
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    height: auto;
    margin: 0;
    border-color: #ffcdac;
    padding: 7px 8px;
    text-align: right;
    text-shadow: none;
    color: #000;
    border-width: 1px;
    height: 24px;
}

.bonus-input-show {
    width: calc(100%);
    border-style: dashed;
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    height: auto;
    margin: 0;
    border-color: #ffcdac;
    padding: 7px 0px;
    text-align: center;
    text-shadow: none;
    color: #000;
    border-width: 1px;
    height: 24px;
}

.anim-btn {
    border-radius: var(--border-small);
    color: #fff;
    background-color: #e46d1e;
    border: none;
    font-size: var(--font-size-body);
    text-transform: uppercase;
    font-weight: var(--font-weight-bold);
    min-width: 160px;
    transition: all ease 0.3s;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    display: inline-block;
    padding: 0px;
    margin: 0px;
    height: 40px;
}

.anim_counter_btn {
    font-size: var(--font-size-body);
    position: absolute;
    animation: peel-cover 3s ease 1s infinite;
    border-radius: var(--border-small);
    box-shadow: none;
    -webkit-clip-path: polygon(0% 0%, calc(100% - 18.3212px) 0%, 100% 100%, 0% 100%);
    clip-path: polygon(0% 0%, calc(100% - 18.3212px) 0%, 100% 100%, 0% 100%);
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}

.anim_bonus-cover {
    position: relative;
    width: 100%;
    height: 40px;
    text-align: center;
    color: var(--color-primary);
    font-size: var(--font-size-body);
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
}

@keyframes peel-cover {
    0%,
    75%,
    100% {
        -webkit-clip-path: polygon(0% 0%, calc(100% - 18.3212px) 0%, 100% 100%, 0% 100%);
        clip-path: polygon(0% 0%, calc(100% - 18.3212px) 0%, 100% 100%, 0% 100%);
    }

    37.5% {
        -webkit-clip-path: polygon(0% 0%, calc(95% - 18.3212px) 0%, 95% 100%, 0% 100%);
        clip-path: polygon(0% 0%, calc(95% - 18.3212px) 0%, 95% 100%, 0% 100%);
    }
}

@keyframes peel-corner {
    0%,
    75%,
    100% {
        right: 0;
        width: 2.5%;
    }

    37.5% {
        right: 5%;
        width: 7.5%;
    }
}

@media (max-width: 576px) {
    .item__content {
        flex-direction: column;
    }

    .item__description {
        gap: var(--spacing-tiny);
    }

    .item__cta,
    .item__date,
    .item__terms,
    .item__book-name {
        text-align: center;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .item__date {
        width: fit-content;
    }

    .buttons {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .button {
        width: 100%;
        font-size: var(--font-size-body);
    }

    .bonus-container {
        display: flex;
        flex-direction: row-reverse;
        gap: var(--spacing-medium);
    }

    .bonus-code {
        font-size: var(--font-size-body);
    }

    .bonus-text {
        font-size: var(--font-size-caption);
    }

    .bonus-fold,
    .bonus-lowerfold {
        display: none;
    }

    .bonus-cover {
        width: 100%;
    }

    .bonus-striped-show {
        grid-template-columns: 1fr;
    }

    .bonus-striped-show div {
        margin: 0.25rem;
    }

    .buttons-grid {
        grid-template-columns: 1fr;
    }

    .buttons-grid .cell {
        margin: 0;
    }
}

.dark-mode .item__book-name,
.dark-mode .item__terms {
    color: var(--color-primary);
}

.dark-mode .item__content {
    background: var(--color-dark-gray-background);
}

.dark-mode .large__terms {
    color: var(--color-primary);
    border-top: 1px solid var(--color-primary);
}

.dark-mode .large__content {
    background: var(--color-dark-gray-background);
}
